"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const divisions = [{
  name: "Kalisch Steel",
  logo: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-1.26.26-p.m.png?v=a704l3f1yyf",
  bgColor: "bg-primary",
  alt: "Logo de Kalisch Steel"
}, {
  name: "Besthal",
  logo: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-1.26.32-p.m.png?v=e9jk7p05qfj",
  bgColor: "bg-destructive",
  alt: "Logo de Besthal"
}, {
  name: "Box Tool",
  logo: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-1.26.47-p.m.png?v=y9a3vuqmm5p",
  bgColor: "bg-foreground",
  alt: "Logo de Box Tool"
}, {
  name: "Faber",
  logo: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-1.26.38-p.m.png?v=0bbubu75a8tv",
  bgColor: "bg-blue-900",
  alt: "Logo de Faber"
}];
export default function CompanyStatistics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="company-statistics" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold font-default text-center mb-12 text-foreground">
            Divisiones
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {divisions.map((division, i) => <div key={i} data-index={i} className={`aspect-square rounded-2xl flex flex-col items-center justify-center p-8 shadow-md transition-transform duration-300 hover:-translate-y-2 ${division.bgColor}`}>
                <img src={division.logo} data-wvc-srcset={`${division.logo}-wvc-srcset`} data-wvc-sizes={`${division.logo}-wvc-sizes`} alt={division.alt} className="w-full h-auto max-w-[160px] object-contain" loading="lazy" />
                {i === 2}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}